import { imgs } from "../assets/imgs";

export const baseSubTeamActivity = {
	id: 0,
	title: "Actividad",
	subtitle: "lorem ipsum",
	insignia: imgs.insignia,
	activityimg: imgs.imgActividad,
	points: 100,
	numberOfTask: 0,
	numberOfTaskCompleted: 0,
	isOpen: false,
	nextActivity: "none",
	task: [
		{
			id: 1,
			imgTask: imgs.imgActividad,
			points: 100,
			pointsWon: 0,
			isOpen: true,
		},
	],
};
